import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a1f44] text-blue-200 py-8 md:py-12 border-t border-blue-900" data-id="element-99">
      <div className="max-w-7xl mx-auto px-4 md:px-8 text-center flex flex-col items-center" data-id="element-100">
        <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-101">🧒</div>
        <h3 className="text-white font-bold text-[15px] md:text-lg mb-1.5 md:mb-2 tracking-tight" data-id="element-102">
          MEGAPACK PSIQUIATRÍA INFANTOJUVENIL PRO™
        </h3>
        <p className="text-[12px] md:text-sm text-blue-300 mb-6 md:mb-8 font-medium" data-id="element-103">
          El sistema N°1 para psiquiatras infantojuveniles de Argentina.
        </p>

        <div className="flex flex-col md:flex-row items-center gap-3 md:gap-8 text-[12px] md:text-sm mb-6 md:mb-8 font-medium" data-id="element-104">
          <a href="mailto:contacto@mundodigitalarg.com" className="hover:text-white transition-colors" data-id="element-105">
            contacto@mundodigitalarg.com
          </a>
          <span className="hidden md:inline text-blue-800" data-id="element-106">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-107">
            @mundodigitalarg
          </a>
        </div>

        <p className="text-[10px] md:text-xs text-blue-500/60 font-medium tracking-wide" data-id="element-108">
          © mundodigitalarg™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}